import NewOrder from '@/features/notifications/components/NotificationCenter/parts/ListItem/NewOrder'
import PostponedOrder from '@/features/notifications/components/NotificationCenter/parts/ListItem/PostponedOrder'
import { OnPress } from '@/features/notifications/components/NotificationCenter/parts/ListItem/types'
import { getHeadingAndCreatedAtProps } from '@/features/notifications/components/NotificationCenter/parts/ListItem/utils/getHeadingAndCreatedAtProps'
import NotificationGuard from '@/features/notifications/notification-service-extension-shared/guards/app'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { getNewOrderProps } from '@/features/notifications/utils/getNewOrderProps'
import { getPostponedOrderProps } from '@/features/notifications/utils/getPostponedOrderProps'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface FactoryProps {
    notification: Notification
    read: boolean
    onPress: OnPress
}

const Factory: FC<FactoryProps> = ({ notification, read, onPress }) => {
    const { t } = useTranslation()

    const getProps = <T extends object>(specialProps: T) => ({
        ...getHeadingAndCreatedAtProps(notification, t),
        ...specialProps,
        read,
        onPress: () => onPress(notification, read),
    })

    if (NotificationGuard.isNewOrder(notification)) {
        return <NewOrder {...getProps(getNewOrderProps(notification, t))} />
    }

    if (NotificationGuard.isPostponedOrder(notification)) {
        return <PostponedOrder {...getProps(getPostponedOrderProps(notification, t))} />
    }

    throw new Error("Notification doesn't match any type")
}

export default memo(Factory)
